import processHtmlAttributes from "../../common/html-attributes"

static var ignoredAttributes = ["class", "size"];

<span
    ...processHtmlAttributes(input, ignoredAttributes)
    class=["progress-spinner", input.size === "large" && "progress-spinner--large", input.class]
    role="img"/>
